/* eslint-disable react/jsx-no-useless-fragment */
import Typography from '@mui/material/Typography';
import { ApolloGqlJobFunnel } from '@bloomays-lib/types.shared';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import RawMainCard from '../atoms/MainCard';
import { getATSJobUrl, getJobTypeLabel } from '@bloomays-lib/utils.shared';
import { IconButton, Logo, SingleLineText, Tag } from '@bloomays-lib/ui.shared';
import hs from '../../graphic-charter/icons/HireSweet.svg';
import { styled } from '@mui/material/styles';

export type CardTJobProps = {
  job: ApolloGqlJobFunnel;
  actionCard?: () => void;
};

const nameReduced = (name: string, maxLength = 50) => {
  return name.length > maxLength ? `${name?.substring(0, maxLength)}...` : name;
};

const CardJob = ({ job }: CardTJobProps) => {
  const { jobType, jobTitle, hubspotDealId, scoreCard1, scoreCard2, scoreCard3, scoreCard4, society } = job;
  let notValidatedClassesRoot: Record<string, unknown> | undefined;

  const jobNameReduced = nameReduced(jobTitle);
  const atsUrl = hubspotDealId ? getATSJobUrl(import.meta.env.VITE_ENV, hubspotDealId) : undefined;
  const header = (
    <>
      <SingleLineText variant={'subtitle2Medium'} text={society?.name} />
      {jobTitle && <SingleLineText variant={'body1Light'} text={jobNameReduced} />}
    </>
  );

  return (
    <MainCard
      sx={notValidatedClassesRoot}
      title={header}
      content={true}
      contentSX={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: 2 }}
      action={
        <>
          {atsUrl && (
            <IconButton aria-label="ats" href={atsUrl} target="_blank">
              <StyledHoverLogo image={hs} />
            </IconButton>
          )}
        </>
      }
    >
      <TagContainer>
        <Tag text={getJobTypeLabel(jobType)} />
      </TagContainer>
      <InfoColumns>
        <InfoColumn>
          {scoreCard1 && (
            <InfoRow>
              <CheckBoxIcon fontSize="small" sx={{ opacity: 0.7 }} />
              <Typography variant="body2" color="textSecondary">
                {nameReduced(scoreCard1, 20)}
              </Typography>
            </InfoRow>
          )}
          {scoreCard2 && (
            <InfoRow>
              <CheckBoxIcon fontSize="small" sx={{ opacity: 0.7 }} />
              <Typography variant="body2" color="textSecondary">
                {nameReduced(scoreCard2, 20)}
              </Typography>
            </InfoRow>
          )}
          {scoreCard3 && (
            <InfoRow>
              <CheckBoxIcon fontSize="small" sx={{ opacity: 0.7 }} />
              <Typography variant="body2" color="textSecondary">
                {nameReduced(scoreCard3, 20)}
              </Typography>
            </InfoRow>
          )}
          {scoreCard4 && (
            <InfoRow>
              <CheckBoxIcon fontSize="small" sx={{ opacity: 0.7 }} />
              <Typography variant="body2" color="textSecondary">
                {nameReduced(scoreCard4, 20)}
              </Typography>
            </InfoRow>
          )}
        </InfoColumn>
      </InfoColumns>
    </MainCard>
  );
};

const StyledHoverLogo = styled(Logo)(
  () => `
  &:hover {
    cursor: pointer;
  }
  width: 24px;
  height: 24px;
`,
);

const MainCard = styled(RawMainCard)({
  maxWidth: 300,
  minWidth: 300,
  maxHeight: 350,
  minHeight: 290,
  margin: '2em 18px',
});

const TagContainer = styled('div')(({ theme }) => ({
  margin: theme.spacing(1.5, 0),
}));

const InfoColumn = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'left',
  gap: 4,
  width: '100%',
}));

const InfoColumns = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}));

const InfoRow = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.75),
}));

export default CardJob;
export { CardJob };
